function SurveyProgressIndicator({progress}) {
    return (
        <div id="graph-part-wrapper">
            <div id="graph-part" style={{
                display: "flex"
            }}>
                <h5>{progress}%</h5>
                <div className="progress">
                    <div id="survey-progress-bar" className="progress-bar g-orange" style={{ width: `${progress}%` }} />
                </div>
            </div>
        </div>
    );
}

export default SurveyProgressIndicator;